import { DataContextService } from 'src/app/services/datacontext.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesConfig } from '../../../configs/routes.config';
import { MsalService } from '@azure/msal-angular';
import { OAuthService } from 'angular-oauth2-oidc';


@Component({
  selector: 'app-user-profile-side-menu',
  templateUrl: './user-profile-side-menu.component.html',
  styleUrls: ['./user-profile-side-menu.component.less'],
})
export class UserProfileSideMenuComponent implements OnInit {
  @Input() isSideMenuToggle = false;
  isUserMenuOpen = false;
  termOfUseLink: string;
  privacyStatementLink: string;
  readonly ROUTES_CONFIG = RoutesConfig.pages;
  // TODO: remove mock user data
  user: any = {
    image: 'assets/icons/userpic.svg',
    name: 'Robert Parker',
    position: 'Project Manager',
  };

  get userData() {
    return DataContextService.UserData;
  }

  get userInitials(): string {
    return this.userData
      ? this.userData.firstName && this.userData.lastName
        ? this.userData.firstName?.charAt(0) + this.userData.lastName?.charAt(0)
        : this.userData.userName?.substring(0, 2)
      : '';
  }
constructor(private authService:OAuthService, private dataContextService: DataContextService) {
    dataContextService.masterDadaLoaded$.subscribe((val: boolean) => {
      if (val) {
        this.termOfUseLink = this.getLinkValue('TermsOfUseURL');
        this.privacyStatementLink = this.getLinkValue('PrivacyURL');
      }
    })
  }

  ngOnInit(): void {}

  openUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  logout(): void {
    window['hotelingDataToken'] = undefined;
    this.authService.logOut();
  }
  navigate() {
    window.open(`/${this.ROUTES_CONFIG.preferences}`, '_blank');
  }
  private getLinkValue(key: string): string | null{
    const property = DataContextService.MemberFirmConfigurations.find(i => i.name === key);
    if (property)
      return property.value;
    else
      return null;
  }
}
